import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { modalNext, modalBack, toggleRecipientTvFilter, toggleTimeFrameTvFilter } from '../../../actions/TVModeAction';

class TVModeModalOptionsComponent extends Component {
  renderIntegrationCheck(shouldRender) {
    if (shouldRender) {
      const { showStats } = this.props;
      return (
        <div style={{ width: 347, display: 'flex', alignItems: 'center' }}>
          <input onChange={() => {
            this.props.chooseShowStats(!showStats);
          }} style={{ height: 18, width: 18 }} type="checkbox" />
          <span className="codecommit-stats">Include CodeCommit Statistics</span>
        </div>
      );
    }
    return null;
  }

  render() {
    const { timeFrameSelected, recipientSelected, toggleRecipientTvFilter, toggleTimeFrameTvFilter } = this.props;
    return (
      <div>
        <div className="toggleButtonsHolder">
          <Button
            className={timeFrameSelected ? 'tv-mode-options selected' : 'tv-mode-options'}
            onClick={toggleTimeFrameTvFilter}
          >
            <div className="icon-holder">
              <div className={timeFrameSelected ? "check-icon" : "timer-icon"}/>
            </div>
            <div className={timeFrameSelected ? "button-font selected-font" : "button-font"}>Specific Time Frame</div>
          </Button>
          <Button
            className={recipientSelected ? 'tv-mode-options selected' : 'tv-mode-options'}
            onClick={toggleRecipientTvFilter}
          >
            <div className="icon-holder">
              <div className={recipientSelected ? "check-icon" : "person-icon"} />
            </div>
            <div className={recipientSelected ? "button-font selected-font" : "button-font"}>Highlight Recipient(s)</div>
          </Button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ tvModeStore }) => {
  const { timeFrameSelected, recipientSelected, showStats }  = tvModeStore;
  return { timeFrameSelected, recipientSelected, showStats };
};

const TVModeModalOptions = connect(mapStateToProps, { modalNext, modalBack, toggleRecipientTvFilter, toggleTimeFrameTvFilter })(TVModeModalOptionsComponent);
export { TVModeModalOptions };


// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModalSections/TVModeModalOptions.js